<!-- 地区选择 -->
<template>
  <div class="areaSelect-component">
    <el-select v-model="proviceId" filterable placeholder="请选择省" @change="selectProvice">
      <el-option v-for="item in proviceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select :disabled="!proviceId" v-model="cityId" filterable placeholder="请选择市" @change="selectCity">
      <el-option v-for="item in cityOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select :disabled="!cityId" v-model="areaId" filterable placeholder="请选择区" @change="selectArea">
      <el-option v-for="item in areaOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
import areaJson from '../../static/area.json'
export default {
  data () {
    return {
      proviceOptions: [],
      cityOptions: [],
      areaOptions: [],
      proviceId: '',
      cityId: '',
      areaId: ''
    }
  },
  created () {
    // 地址数据最外层是省，依次往里是市，最后是区县，这里只先给省赋值
    this.proviceOptions = areaJson
  },
  methods: {
    // 选择省，根据省id设置城市选项
    selectProvice (id) {
      console.log('selectProvice--')
      this.cityOptions = []
      this.areaOptions = []
      this.cityId = ''
      this.areaId = ''
      this.$emit('select', '')
      const index = this.proviceOptions.findIndex((item) => { return item.id === id })
      this.cityOptions = this.proviceOptions[index].children
    },
    // 选择市，根据城市id设置区县选项
    selectCity (id) {
      console.log('selectCity--')
      this.areaOptions = []
      this.areaId = ''
      this.$emit('select', '')
      const index = this.cityOptions.findIndex((item) => { return item.id === id })
      this.areaOptions = this.cityOptions[index].children
    },
    // 选择区县，拿到最后的full_name
    selectArea (id) {
      console.log('selectArea--')
      const index = this.areaOptions.findIndex((item) => { return item.id === id })
      this.$emit('select', this.areaOptions[index].full_name)
    }
  }
}
</script>

<style lang="scss">
.areaSelect-component {
  display: inline-block;
  .el-select {
    width: 170px;
  }
  .el-select+.el-select {
    margin-left: 3px;
  }
}
</style>
